var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            { staticStyle: { "overflow-y": "auto" } },
            [
              _vm.isMobilePort
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-center justify-space-between",
                      },
                      [
                        _c("h3", { staticClass: "mb-3" }, [_vm._v("Filters")]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "" },
                            on: { click: _vm.handleClose },
                          },
                          [_c("v-icon", [_vm._v("mdi-close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ])
                : _c("div", [
                    _c("h3", { staticClass: "mb-3" }, [_vm._v("Filters")]),
                  ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "my-5" },
                [
                  _vm.isMobilePort
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mb-2",
                          attrs: { color: "primary", block: "" },
                          on: { click: _vm.applyFilters },
                        },
                        [
                          _vm._v(
                            "\n                    Apply\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", block: "" },
                      on: { click: _vm.resetFilters },
                    },
                    [
                      _vm._v(
                        "\n                    Reset Filters\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-divider", { staticClass: "my-5" }),
                ],
                1
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "mb-2" }, [_vm._v("Notes")]),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  label: "Project Tag",
                  items: _vm.filters.tags,
                  "item-text": "text",
                  "item-value": "value",
                  clearable: "",
                  outlined: "",
                  dense: "",
                  multiple: "",
                  "menu-props": { bottom: true, offsetY: true },
                },
                model: {
                  value: _vm.activeFilters.tags,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeFilters, "tags", $$v)
                  },
                  expression: "activeFilters.tags",
                },
              }),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  label: "Created By",
                  items: _vm.filters.createdBy,
                  clearable: "",
                  outlined: "",
                  dense: "",
                  multiple: "",
                  "menu-props": { bottom: true, offsetY: true },
                },
                model: {
                  value: _vm.activeFilters.createdBy,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeFilters, "createdBy", $$v)
                  },
                  expression: "activeFilters.createdBy",
                },
              }),
              _vm._v(" "),
              _vm.userProfileType === "enterprise"
                ? _c("v-select", {
                    attrs: {
                      label: "Visibility",
                      items: _vm.filters.visibility,
                      clearable: "",
                      outlined: "",
                      dense: "",
                      "menu-props": { bottom: true, offsetY: true },
                    },
                    model: {
                      value: _vm.activeFilters.visibility,
                      callback: function ($$v) {
                        _vm.$set(_vm.activeFilters, "visibility", $$v)
                      },
                      expression: "activeFilters.visibility",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("v-select", {
                attrs: {
                  label: "Date",
                  items: _vm.filters.createdDate,
                  clearable: "",
                  outlined: "",
                  dense: "",
                  "menu-props": { bottom: true, offsetY: true },
                },
                model: {
                  value: _vm.activeFilters.createdDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeFilters, "createdDate", $$v)
                  },
                  expression: "activeFilters.createdDate",
                },
              }),
              _vm._v(" "),
              _c("v-divider", { staticClass: "my-2" }),
              _vm._v(" "),
              _c("h4", { staticClass: "mb-2" }, [_vm._v("Titles")]),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  label: "Title",
                  items: _vm.filters.titles,
                  clearable: "",
                  outlined: "",
                  dense: "",
                  multiple: "",
                  "menu-props": { bottom: true, offsetY: true },
                },
                model: {
                  value: _vm.activeFilters.titles,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeFilters, "titles", $$v)
                  },
                  expression: "activeFilters.titles",
                },
              }),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  label: "Category",
                  items: _vm.filters.categories,
                  clearable: "",
                  outlined: "",
                  dense: "",
                  multiple: "",
                  "menu-props": { bottom: true, offsetY: true },
                },
                model: {
                  value: _vm.activeFilters.categories,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeFilters, "categories", $$v)
                  },
                  expression: "activeFilters.categories",
                },
              }),
              _vm._v(" "),
              _c("v-autocomplete", {
                attrs: {
                  label: "Year",
                  items: _vm.filters.years,
                  clearable: "",
                  outlined: "",
                  dense: "",
                  multiple: "",
                  "menu-props": { bottom: true, offsetY: true },
                },
                model: {
                  value: _vm.activeFilters.years,
                  callback: function ($$v) {
                    _vm.$set(_vm.activeFilters, "years", $$v)
                  },
                  expression: "activeFilters.years",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }